import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip, Spin } from 'antd';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { fieldfilter } from '../../redux/actions/customFunction';
import { intialPaginationState, showingPageTotalRange } from '../../common_functions';

const Configure = props => {
  const [configurations, setConfigurations] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [types, setTypes] = useState(false);
  const [conditions, setConditions] = useState(false);
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        let { data: { meta: { options: { choices: type = [] } = {} } = {} } = {} } = await props.fetchFieldValues('configuration', {
          fields: ['type'],
        });
        setTypes(type);
        let { data: { meta: { options: { choices: condition = [] } = {} } = {} } = {} } = await props.fetchFieldValues('configuration', {
          fields: ['condition'],
        });
        setConditions(condition);
        getConfig(pagination);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    }
    fetchData();
  }, []);
  const getConfig = async pagination => {
    const response = await props.getItems('configuration', {
      fields: ['id,value,value_2,name,type,condition'],
      sort: 'id',
      offset: pagination.pageSize * (pagination.current - 1),
      limit: pagination.pageSize,
      meta: 'filter_count',
    });
    pagination.total = response.meta.filter_count;
    setPagination(pagination);
    setConfigurations(response.data);
  };
  const columns = [
    {
      title: 'Field Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Value',
      key: 'value',
      render: (text, record) => {
        return !!record.value_2 ? <span>{record.value + ' - ' + record.value_2}</span> : record.value;
      },
    },
    {
      title: 'Condition',
      dataIndex: 'condition',
      key: 'condition',
      render: condition => {
        return <span>{fieldfilter(conditions, condition)}</span>;
      },
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: type => {
        return <span>{fieldfilter(types, type)}</span>;
      },
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        // Hide delete and edit permission for readonly user
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/configuration/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_configuration?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_configuration?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
          </div>
        </span>
      ),
    },
  ];

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col span={24} className="app-breadcrumb-col">
          <Breadcrumb items={[{ title: "Settings", href: "/settings/configuration" }, { title: "Configurations" }]} />
        </Col>
        <Col className="white-paper" span={24}>
          <div className="dashboard">
            <Row gutter={24} className="page-header-section" align="middle">
              <Col xs={12}>
                <Typography.Title level={4} style={{ margin: 0 }}>
                  View Configurations
                </Typography.Title>
              </Col>
            </Row>
            <hr />
            <div className="artist-list">
              <Table
                scroll={{ x: 'max-content' }}
                columns={columns}
                bordered
                rowKey={record => record.id}
                dataSource={configurations}
                pagination={{ ...pagination, ...showingPageTotalRange }}
                loading={loading}
                onChange={getConfig}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};
export default Configure;
